import React from 'react';

// Nombre del comercio con su logo al lado (o 🏪 si todavía no subió uno)
export default function ComercioNombre({ comercio, className = 'regalar-comercio-name' }) {
  return (
    <div className={`comercio-nombre ${className}`}>
      {comercio.logo_path
        ? <img src={comercio.logo_path} alt="" className="comercio-logo" loading="lazy" />
        : <span className="comercio-logo comercio-logo--vacio">🏪</span>}
      <span>{comercio.nombre}</span>
    </div>
  );
}
